<template>

	<div class="">
		<div style="width:100%,height:100px;background-color:white"></div>
		<v-header :inputName='3'></v-header>
		<div class="container">
			<div class="toubu">
				<div class="toubu_top">
					<div class="toubu-left">
						<div class="left-top">
							<div class="top-pic">
								<img src="../../../../static/img/jingji.png">
							</div>
							<div class="top-right">
								<div class="top-word" style="font-size: 24px; font-weight:800; margin-bottom:10px; ">
									{{majorObj.majorName}}
								</div>
								<div class="top-btn">
									<button type="button">{{majorObj.majorParentTypeId}}</button>
									<button type="button">{{majorObj.majorTypeId}}</button>
								</div>
							</div>
						</div>

					</div>
					<div class="toubu-right">
            <div class="left-bottom">
            	<span>{{majorObj.majorEducation==1?'本科':'专科'}}：{{majorObj.majorSystem}}年</span>
            	<!-- <span>毕业学位：经济学士</span> -->
            	<span>男女比例：<label style="font-weight: 0;">{{majorObj.majorProportion}}</label></span>
            </div>


						<!-- <div class="right-top">
							<span>录取分偏高院校:</span>
						</div>
						<div class="right-bottom">
							<router-link to="">北京大学、</router-link>
							<router-link to="">中国人民大学、</router-link>
							<router-link to="">上海交通大学、</router-link>
							<router-link to="">复旦大学、</router-link>
							<router-link to="">南开大学、</router-link>
							<router-link to="">厦门大学、</router-link>
							<router-link to="">中山大学、</router-link>
							<router-link to="">武汉大学、</router-link>
							<router-link to="">中国传媒大学、</router-link>
							<router-link to="">东南大学</router-link>
						</div>
 -->
					</div>
					<div class="shoucang" >
						<span @click="shou(id)" :class="{active:userCang.indexOf(id)!=-1}">{{userCang.indexOf(id)!=-1?'已收藏':'收藏'}}<img src="../../../../static/img/shoucang.png"></span>
					</div>
				</div>
				<div class="zhanwei">
					<li v-for="(item,index) in erjidao" :style="{width:(100/erjidao.length)+'%'}" :key="index" :class="[xhuan== index?'zhanwei1':'zhanwei2']" @click="tiehuan(index)">
						<img :src="item.img1" v-if = "xhuan !== index">
						<img :src="item.img2" v-else>
						<span>{{item.span}}</span>
					</li>
				</div>
			</div>

			<zhuanyejieshao :id="id" v-if="xhuan == 0"></zhuanyejieshao>
			<kaoyanyujiuye :id="id" v-if="xhuan == 1"></kaoyanyujiuye>
      <kaisheyuanxiao :id="id" v-if="xhuan == 2"></kaisheyuanxiao>
			<kechengshezhi :id="id" v-if="xhuan == 3"></kechengshezhi>
			<zhishinengli :id="id" v-if="xhuan == 4"></zhishinengli>
			<!-- <kaisheyuanxiao :id="id" v-if="xhuan == 5"></kaisheyuanxiao> -->
		</div>
		<zuoxuanfu1></zuoxuanfu1>
		<item7></item7>
	</div>
</template>

<script>
import vHeader from '../../../components/vHeader.vue'
import zuoxuanfu1 from '../../../components/zuoxuanfu1.vue'
import item7 from '../../../components/item7.vue'
import zhuanyejieshao from './zhuanyejieshao.vue'
import kechengshezhi from './kechengshezhi.vue'
import zhishinengli from './zhishinengli.vue'
import kaoyanyujiuye from './kaoyanyujiuye.vue'
import kaisheyuanxiao from './kaisheyuanxiao.vue'

	export default {
		name: "",
		components: {
			vHeader,
			zuoxuanfu1,
			item7,
			zhuanyejieshao,
			kechengshezhi,
			zhishinengli,
			kaoyanyujiuye,
			kaisheyuanxiao
		},
		data() {
			return {
				// 导航选中
				xhuan:0,
        id:'',
				erjidao:[
					{img1:require("../../../assets/img/zhuanye10.png"),img2:require("../../../assets/img/zhuanye5.png"),span:"专业信息"},
					// {img1:require("../../../assets/img/zhuanye3.png"),img2:require("../../../assets/img/zhuanye6.png"),span:"课程设置"},
					// {img1:require("../../../assets/img/zhuanye4.png"),img2:require("../../../assets/img/zhuanye7.png"),span:"知识能力"},
					{img1:require("../../../assets/img/zhuanye1.png"),img2:require("../../../assets/img/zhuanye8.png"),span:"就业分析"},
					{img1:require("../../../assets/img/zhuanye2.png"),img2:require("../../../assets/img/zhuanye9.png"),span:"开设院校"},
				],
        majorObj:{},
        userCang:[]
			}
		},
		methods: {
			tiehuan(index){
				this.xhuan = index
			},
      shou(id) {
      	let _this = this;
      	let flag1 = this.$utils.getLoginStatus();
      	if (flag1) {
      		let obj = this.$utils.getlocalStorage('userCang')
      		let list = obj.major
      		if (list.indexOf(id) == -1) {
      			_this.$req.insert("collectionTable", {
      				dataType: 2,
      				dataId: id
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.push(id);
      					_this.userCang = list
      					obj.major = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})
      
      		} else {
      			_this.$req.batchDelete("collectionTable", {
      				data_type: 2,
      				data_id: id
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.splice(list.indexOf(id), 1);
      					_this.userCang = list
      					obj.major = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})
      		}
      	}
      },

		},
    created() {

      let _this = this;
      let userCang = this.$utils.getlocalStorage('userCang')
      if(userCang!=null&&userCang!=''){
        this.userCang = userCang.major
      }
      this.id= this.$route.query.id
      console.log(this.id)
      this.$req.selectOne("majorTable", {
      	id: this.$route.query.id
      }).then(function(response) {
      	_this.majorObj = response.data
      })
    },
    mounted() {

    }


	}
</script>

<style scoped>
	.zhanwei {
		width: 100%;
		height: 46px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	.zhanwei li{
		width: 25%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: -1px -1px 1px rgb(6 0 1 / 41%);
		cursor: pointer;
	}
	.zhanwei1{
		background: #F53824;
	}
	.zhanwei1 span{
		background: #F53824;
		color: #FFFFFF;
	}
	.zhanwei2 span{
		color: #333333;
	}

	.zhanwei li span{
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;

	}
	.zhanwei li img{
		height: 18px;
		margin-right: 10px;
	}
	.container{
		width: 73%;
	}
	.intro1{
		margin-bottom: 20px;
	}
	.intro2{
		margin-bottom: 20px;
	}
	.intro3{
		margin-bottom: 20px;
	}
	.nr span {
		font-size: 16px;
		font-weight: 500;
		color: #666666;
		opacity: 1;

	}

	.nr {
		display: block;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.zhuanye-intro {
		line-height: 35px;
		display: block;
	}

	.intro3-tit span {
		margin-left: 5px;
		font-size: 20px;
		font-weight: 500;
		color: #333333;
		opacity: 1;
		margin-top: -8px;

	}
	.intro2-tit{
		margin-bottom: 15px;
	}
	.intro2-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;

	}
	.intro1-tit{
		margin-bottom: 15px;
	}
	.intro1-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;
	}

	.wl {
		width: 6px;
		height: 22px;
		border-radius: 0px 4px 4px 0px;
		background: #F21323;
	}

	.intro1-tit {
		display: flex;
	}

	.intro2-tit {
		display: flex;
	}

	.intro3-tit {
		display: flex;
	}


	.top-btn{
		display: flex;
	}
	.top-btn button {
		/* width: 76px; */
    padding: 5px 20px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgb(241, 241, 241);
		opacity: 1;
		border-radius: 21px;
		border: none;
		color: #666666;
	}
	.top-btn button:nth-of-type(1){
		margin-right: 15px;
	}
	.left-bottom{
		margin-top: 20px;
	}
	.left-bottom span{
		margin-right: 15px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #666666;
	}
	.left-bottom span:nth-of-type(3){
		margin-right: 0;
	}
	.left-bottom span:nth-of-type(3) label{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}
	.shoucang span img {
		margin-left: 5px;
	}

  .shoucang .active {
    background: #F21323;
  }
	.shoucang span {
		width: 100px;
		height: 34px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(134deg, #3EC2FF 0%, #29A7E1 100%);
		opacity: 1;
		border-radius: 21px;
		color: white;
		padding: 0px 5px 0 5px;
	}

	.shoucang {
		margin-left: 10px;
	}

	a {
		color: #29A7E1;
		text-decoration: none;
	}

	.top-right {
		line-height: 41px;
		display: block;
		margin-left: 14px;
	}

	.left-top {
		display: flex;
	}

	.toubu-right {
		line-height: 30px;
		display: block;
		margin-left: 40px;
		margin-top: 33px;
	}

	.toubu-left {
		display: block;
		flex-shrink: 0;
	}
	.right-top span{
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
	}
	.right-bottom a{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}
	.toubu_top{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		padding: 30px 30px 0 30px;
		box-sizing: border-box;
	}
	.toubu {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 175px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
		opacity: 1;
		border-radius: 5px 5px 0 0;
		margin-top: 100px;
		margin-bottom: 40px;
	}
	@media (max-width:750px) {
		.toubu{
			display: block;
		}
		.toubu-right{
			margin: 0;
		}
		.shoucang{
			text-align: right;
		}
		.container{
			width: 100%;
		}

		.toubu{width: 100%;overflow-y: hidden;overflow-x: auto;}
		.toubu_top{width: 900px;}
		.zhanwei{width: 900px;}

	}
</style>



// WEBPACK FOOTER //
// src/views/information/majorinfo/zyxq_zhuanyejieshao.vue